import { useEffect, useState } from 'react';

function Toast({ message, isVisible, onClose }) {
  const [isFadingOut, setIsFadingOut] = useState(false);
  const [mobileMenuHeight, setMobileMenuHeight] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  // Check if mobile and update mobile menu height
  useEffect(() => {
    const updateMobileMenuHeight = () => {
      const isMobileView = window.innerWidth < 768; // md breakpoint
      setIsMobile(isMobileView);
      
      if (isMobileView) {
        const mobileNav = document.querySelector('nav.md\\:hidden');
        if (mobileNav) {
          const navRect = mobileNav.getBoundingClientRect();
          setMobileMenuHeight(navRect.height);
        }
      } else {
        setMobileMenuHeight(0);
      }
    };

    if (isVisible) {
      updateMobileMenuHeight();
      // Update on resize and periodically to catch menu expansion
      const interval = setInterval(updateMobileMenuHeight, 100);
      const resizeHandler = () => updateMobileMenuHeight();
      window.addEventListener('resize', resizeHandler);

      return () => {
        clearInterval(interval);
        window.removeEventListener('resize', resizeHandler);
      };
    }
  }, [isVisible]);

  useEffect(() => {
    if (isVisible) {
      // Start fade out after 2.7 seconds (0.3s before removal)
      const fadeOutTimer = setTimeout(() => {
        setIsFadingOut(true);
      }, 2700);

      // Remove from DOM after fade out completes
      const removeTimer = setTimeout(() => {
        onClose();
        setIsFadingOut(false);
      }, 3000);

      return () => {
        clearTimeout(fadeOutTimer);
        clearTimeout(removeTimer);
      };
    } else {
      setIsFadingOut(false);
    }
  }, [isVisible, onClose]);

  if (!isVisible) return null;

  // Calculate top position: on mobile, use mobile menu height + spacing, otherwise use fixed top-24
  const topPosition = isMobile && mobileMenuHeight > 0 
    ? mobileMenuHeight + 40 // 40px spacing below mobile menu for better separation
    : 96; // top-24 = 96px for desktop

  return (
    <div 
      className="fixed left-1/2 transform -translate-x-1/2 z-[10000] pointer-events-none md:top-24"
      style={{ 
        top: isMobile ? `${topPosition}px` : undefined 
      }}
    >
      <div className={`bg-white rounded-full shadow-lg border border-[#E5E5E5] px-4 py-3 flex items-center gap-3 pointer-events-auto ${isFadingOut ? 'animate-fade-out-up' : 'animate-fade-in-down'}`}>
        <span className="material-symbols-outlined" style={{ fontSize: '20px', fontVariationSettings: '"FILL" 1', color: '#6eb32a' }}>
          check_circle
        </span>
        <span className="text-sm font-medium text-[#0D0D0D]">{message}</span>
      </div>
    </div>
  );
}

export default Toast;
